/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_TitleInputs */

const en_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

const fr_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

const de_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

const it_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

const ru_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

const es_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

const zh_cn2_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

const ja_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

const hi_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

const pt_pt2_options_metrics_title = /** @type {(inputs: Options_Metrics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Settings`)
};

/**
* | output |
* | --- |
* | "Metrics Settings" |
*
* @param {Options_Metrics_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_title = /** @type {((inputs?: Options_Metrics_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_title(inputs)
	if (locale === "de") return de_options_metrics_title(inputs)
	if (locale === "it") return it_options_metrics_title(inputs)
	if (locale === "ru") return ru_options_metrics_title(inputs)
	if (locale === "es") return es_options_metrics_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_title(inputs)
	if (locale === "ja") return ja_options_metrics_title(inputs)
	if (locale === "hi") return hi_options_metrics_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_title(inputs)
	return en_options_metrics_title(inputs)
});